import React from 'react';
import { PLUGIN_TOOLBAR_BUTTON_ID } from 'wix-rich-content-editor-common';
import { EditHtmlButton } from './toolbar/EditHtmlButton.js';
import { DimensionSliderButton } from './toolbar/DimensionSliderButton.js';
import { TIPTAP_HTML_TYPE } from 'ricos-content';
import { MAX_HEIGHT_INPUT, MIN_HEIGHT, MAX_HEIGHT, MAX_WIDTH, MIN_WIDTH } from './defaults.js';
import { selectedNodeResolver, WidthIcon, HeightIcon } from 'wix-rich-content-plugin-commons';
import { AlignmentPanel, NodeAlignmentButton } from 'wix-rich-content-toolbars-ui';
import HtmlEditPanelTiptap from './toolbar/HtmlEditPanelTiptap.js';
import SliderModal from './toolbar/SliderModal.js';
import { HTML_BUTTONS } from './consts.js';
import 'ricos-context';
import 'ricos-types';
import 'ricos-schema';
import './toolbar/HtmlEditPanel.js';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import 'lodash';
import './AdsenseTitle.js';
import './style-inject.es-746bb8ed.js';

const getToolbarButtons = (config, services) => {
  const {
    minHeight = MIN_HEIGHT,
    maxHeight = MAX_HEIGHT,
    maxWidth = MAX_WIDTH,
    minWidth = MIN_WIDTH
  } = config || {};
  return [
    {
      id: HTML_BUTTONS.edit,
      dataHook: "baseToolbarButton_edit",
      command: ({ htmlData, editorCommands }) => {
        editorCommands.chain().updateAttributes(TIPTAP_HTML_TYPE, htmlData).run();
      },
      modal: {
        Component: HtmlEditPanelTiptap,
        id: HTML_BUTTONS.edit
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(EditHtmlButton, { toolbarItem }),
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: HTML_BUTTONS.width,
      command: ({ data, editorCommands }) => {
        editorCommands.chain().updateAttributes(TIPTAP_HTML_TYPE, data).run();
      },
      modal: {
        Component: SliderModal,
        id: HTML_BUTTONS.width
      },
      icon: WidthIcon,
      tooltip: "ChangeDimensions_Width_Tooltip",
      dataHook: "html_custom_width_slider",
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(
        DimensionSliderButton,
        {
          toolbarItem,
          dimension: "width",
          min: minWidth,
          max: maxWidth,
          inputMax: MAX_HEIGHT_INPUT
        }
      ),
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: HTML_BUTTONS.height,
      command: ({ data, editorCommands }) => {
        editorCommands.chain().updateAttributes(TIPTAP_HTML_TYPE, data).run();
      },
      modal: {
        Component: SliderModal,
        id: HTML_BUTTONS.height
      },
      icon: HeightIcon,
      tooltip: "ChangeDimensions_Height_Tooltip",
      dataHook: "html_custom_height_slider",
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(
        DimensionSliderButton,
        {
          toolbarItem,
          dimension: "height",
          min: minHeight,
          max: maxHeight,
          inputMax: MAX_HEIGHT_INPUT
        }
      ),
      attributes: {
        selectedNode: selectedNodeResolver
      }
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.ALIGNMENT,
      modal: {
        Component: AlignmentPanel,
        id: HTML_BUTTONS.alignment
      },
      renderer: (toolbarItem) => /* @__PURE__ */ React.createElement(NodeAlignmentButton, { toolbarItem, id: HTML_BUTTONS.alignment })
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.SEPARATOR
    },
    {
      id: PLUGIN_TOOLBAR_BUTTON_ID.DELETE
    }
  ];
};

export { getToolbarButtons };
//# sourceMappingURL=getToolbarButtons.js.map
